import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
//import api_base_url from "../../config";
import axiosInstance from "../../../../api/axiosInstance";

const initialState = {
  records: [],
  selectedRecords: [],
  recordRetrievalStatus: "idle",
  recordRetrievalError: null,
  sendToOneKeyStatus: null,
  sendToOneKeyError: null,
  getOneKeyStatus: null,
  getOneKeyError: null,
  completeJobsAPI: null,
  completeJobsError: null,
  retrievedColumnHeaders: null,
  retrievedColumnHeadersStatus: "idle",
  retrievedColumnHeadersError: null,
  validateAddressStatus: null,
  validateAddressError: null,
  isLoading: false,
};

export const fetchRecords = createAsyncThunk(
  "displayRecords/fetchRecords",
  async ({ jobId }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `/api/DataView/GetChiesiData?jobId=${jobId}`,
        {
          headers: {
           // Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const sendOneKeyValidation = createAsyncThunk(
  "displayRecords/sendOneKeyValidation",
  async ({ dataRecord, jobId, userId, level, userMail, token }) => {
    if (!token) {
      throw new Error("Missing user token");
    }

    const response = await axiosInstance.post(
      `/api/HCA/SendOnekeyValidation?JobId=${jobId}&UserId=${userId}&level=${level}&UserMail=${userMail}`,
      dataRecord,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  }
);

export const oneKeyStatus = createAsyncThunk(
  "displayRecords/oneKeyStatus",
  async ({ dataRecord, jobId, userId, token }) => {
    if (!token) {
      throw new Error("Missing user token");
    }

    const response = await axiosInstance.post(
      `/api/HCA/GetOnekeyStatus?JobId=${jobId}&UserId=${userId}`,
      dataRecord,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  }
);

export const completeJobsAPI = createAsyncThunk(
  "displayRecords/completeJobsAPI",
  async ({ jobId }) => {
    // if (!token) {
    //   throw new Error("Missing user token");
    // }
    await axiosInstance.post(
      `/api/DataView/CompleteJobs?jobId=${jobId}`,
      {},
      {
        headers: {
          //Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
  }
);

export const retrieveColumnsByJobId = createAsyncThunk(
  "displayRecords/retrieveColumnsByJobId",
  async ({ jobId }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `/api/Jobs/RetrieveColumnsByJobId?jobId=${jobId}`,
        {
          headers: {
           // Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const validateAddressApi = createAsyncThunk(
  "displayRecords/validateAddressApi",
  async ({ dataRecord, jobId, userId, userMail }, { rejectWithValue }) => {
    try {
      // if (!token) {
      //   throw new Error("Missing user token");
      // }

      const response = await axiosInstance.post(
        `/api/HCA/ValidateAddress?JobId=${jobId}&UserId=${userId}&UserMail=${userMail}`,
        dataRecord,
        {
          headers: {
            //Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const displayRecordsSlice = createSlice({
  name: "displayRecords",
  initialState,
  reducers: {
    setSelectedRecords(state, action) {
      state.selectedRecords = action.payload;
    },
    clearRecords(state) {
      state.records = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRecords.pending, (state) => {
        state.isLoading = true;
        state.recordRetrievalStatus = "loading";
        state.recordRetrievalError = null;
      })
      .addCase(fetchRecords.fulfilled, (state, action) => {
        state.isLoading = false;
        state.recordRetrievalStatus = "succeeded";
        state.records = action.payload;
      })
      .addCase(fetchRecords.rejected, (state, action) => {
        state.isLoading = false;
        state.recordRetrievalStatus = "failed";
        state.recordRetrievalError = action.error.message;
        state.records = [];
      })
      .addCase(sendOneKeyValidation.pending, (state) => {
        state.sendToOneKeyStatus = "loading";
        state.sendToOneKeyError = null;
      })
      .addCase(sendOneKeyValidation.fulfilled, (state) => {
        state.sendToOneKeyStatus = "succeeded";
        state.selectedRecords = [];
      })
      .addCase(sendOneKeyValidation.rejected, (state, action) => {
        state.sendToOneKeyStatus = "failed";
        state.sendToOneKeyError = action.error.message;
        state.selectedRecords = [];
      })
      .addCase(oneKeyStatus.pending, (state) => {
        state.getOneKeyStatus = "loading";
        state.getOneKeyError = null;
      })
      .addCase(oneKeyStatus.fulfilled, (state) => {
        state.getOneKeyStatus = "succeeded";
        state.selectedRecords = [];
      })
      .addCase(oneKeyStatus.rejected, (state, action) => {
        state.getOneKeyStatus = "failed";
        state.getOneKeyError = action.error.message;
        state.selectedRecords = [];
      })
      .addCase(completeJobsAPI.pending, (state) => {
        state.completeJobsAPI = "loading";
        state.completeJobsError = null;
      })
      .addCase(completeJobsAPI.fulfilled, (state) => {
        state.completeJobsAPI = "succeeded";
      })
      .addCase(completeJobsAPI.rejected, (state, action) => {
        state.completeJobsAPI = "failed";
        state.completeJobsError = action.error.message;
      })
      .addCase(retrieveColumnsByJobId.pending, (state) => {
        state.retrievedColumnHeadersStatus = "loading";
        state.retrievedColumnHeadersError = null;
      })
      .addCase(retrieveColumnsByJobId.fulfilled, (state, action) => {
        state.retrievedColumnHeadersStatus = "succeeded";
        state.retrievedColumnHeaders = action.payload;
      })
      .addCase(retrieveColumnsByJobId.rejected, (state, action) => {
        state.retrievedColumnHeadersStatus = "failed";
        state.retrievedColumnHeadersError = action.error.message;
      })
      .addCase(validateAddressApi.pending, (state) => {
        state.validateAddressStatus = "loading";
        state.validateAddressError = null;
      })
      .addCase(validateAddressApi.fulfilled, (state) => {
        state.validateAddressStatus = "succeeded";
        state.selectedRecords = [];
      })
      .addCase(validateAddressApi.rejected, (state, action) => {
        state.validateAddressStatus = "failed";
        state.validateAddressError = action.payload || action.error.message;
        state.selectedRecords = [];
      });
  },
});

export const { setSelectedRecords, clearSelectedRecords, clearRecords } =
  displayRecordsSlice.actions;

export default displayRecordsSlice.reducer;
